import CommonState from '@/class/cargo/model/parameters/CommonState'

export function getCommonState(code, list) {
  for (const common of list) {
    if (common.code === code) {
      return common
    }
  }
  return null
}

// ---------------------
// Entry Type
// ---------------------

export const ACCOUNT_RECEIVABLE = new CommonState(1, '应收账款', 'Account Receivable')
export const ACCOUNT_RECEIVABLE_NO_INVOICE = new CommonState(2, '应收账款(未开票)', 'Account Receivable (No Invoice)')
export const ACCOUNT_PAYABLE = new CommonState(3, '应付账款', 'Account Payable')
export const ACCOUNT_PAYABLE_NO_INVOICE = new CommonState(4, '应付账款(未开票)', 'Account Payable (No Invoice)')
export const REVENUE = new CommonState(5, '营业收入', 'Revenue')
export const REVENUE_NO_INVOICE = new CommonState(6, '营业收入(未开票)', 'Revenue (No Invoice)')
export const COST = new CommonState(7, '营业成本', 'Cost')
export const COST_NO_INVOICE = new CommonState(8, '营业成本(未开票)', 'Cost (No Invoice)')
export const CASH = new CommonState(9, '现金', 'Cash')
export const BANK_DEPOSIT = new CommonState(10, '银行存款', 'Bank Deposit')
export const TAX_RECEIVABLE = new CommonState(11, '应收税款', 'Tax Receivable')
export const TAX_PAYABLE = new CommonState(12, '应付税款', 'Tax Payable')
export const FINANCIAL_RECEIVABLE = new CommonState(13, '财务费用总和(应收)', 'Financial Receivable')
export const FINANCIAL_PAYABLE = new CommonState(14, '财务费用总和(应付)', 'Financial Payable')
export const REVENUE_EXT = new CommonState(15, '资金往来', 'RevenueExt')
export const EXCHANGE_GAIN_OR_LOSS_RECEIVABLE = new CommonState(16, '汇兑损益(应收)', 'Exchange gain or loss Receivable')
export const EXCHANGE_GAIN_OR_LOSS_PAYABLE = new CommonState(17, '汇兑损益(应付)', 'Exchange gain or loss Payable')
export const FINANCIAL_CLEARODD_RECEIVABLE = new CommonState(22, '财务费用&零头短账(应收)', 'Financial ClearOdd Receivable')
export const FINANCIAL_CLEARODD_PAYABLE = new CommonState(23, '财务费用&零头短账(应付)', 'Financial ClearOdd Payable')
export const AGENT_BUSINESS = new CommonState(24, '代收代付', 'Agent Business')
export const REVENUE_DIFF = new CommonState(25, '营业收入(差额)', 'Revenue Diff')
export const ACCOUNTS_RECEIVABLE = new CommonState(26, '预收账款', 'Accounts receivable')
export const OTHERS_RECEIVABLE = new CommonState(27, '其他应收款', 'Others receivable')
export const OTHERS_PAYABLE = new CommonState(28, '其他应付款', 'Others Payable')
export const CHECK = new CommonState(29, '支票', 'Check')
export const SELF = new CommonState(30, '本票', 'Self')
export const CASHTRANSFER = new CommonState(31, '水单', 'CashTransfer')
// CARGO-6529，宏信(4721)：客户和供应商双重角色的凭证生成规则
export const CUSTOMER = new CommonState(32, '客户', 'Customer')
export const VENDOR = new CommonState(33, '供应商', 'Vendor')

export const BANK_ACCEPTANCE_BILL = new CommonState(50, '银行承兑汇票', 'BankAcceptanceBill')
export const COMMERCIAL_ACCEPTANCE_BILL = new CommonState(51, '商业承兑汇票', 'CommercialAcceptanceBill')
// CARGO-5643 凭证增加分录项：应收发票差额、应付发票差额
export const INVOICE_RECEIVABLE_HEDGING = new CommonState(52, '应收发票(对冲)', 'Invoice receivable (hedging)')
export const INVOICE_PAYABLE_HEDGING = new CommonState(53, '应付发票(对冲)', 'Invoice payable (hedging)')

export const COST_HEDGING = new CommonState(54, '营业成本(对冲)', 'Cost (hedging)')
export const REVENUE_HEDGING = new CommonState(55, '营业收入(对冲)', 'Revenue (hedging)')

export const FINANCIAL_EXPENSES_RECEIVABLE = new CommonState(56, '财务费用(应收)', 'Financial Expenses Receivable')
export const FINANCIAL_EXPENSES_PAYABLE = new CommonState(57, '财务费用(应付)', 'Financial Expenses Payable')
export const ODD_SHORT_ACCOUNT_RECEIVABLE = new CommonState(58, '零头短账(应收)', 'Odd Short Account Receivable')
export const ODD_SHORT_ACCOUNT_PAYABLE = new CommonState(59, '零头短账(应付)', 'Odd Short Account Payable')

// CARGO-6530，总部代付金额生成凭证规则
// 1、分公司
//		分公司不涉及银行类凭证
//		如果是收代理，借 其它应收（上海）
//		                贷 应收账款  （代理）
//		如果是付代理：借 应付账款（海外代理）
//		                贷 其它应收款（上海）红数
export const ACCOUNT_RECEIVABLE_OVERSEA = new CommonState(34, '应收账款(海外代理)', 'Account Receivable (Oversea)')
export const ACCOUNT_PAYABLE_OVERSEA = new CommonState(35, '应付账款(海外代理)', 'Account Payable (Oversea)')
export const OTHERS_RECEIVABLE_CENTER = new CommonState(36, '其他应收款(总部)', 'Others receivable (Center)')
export const OTHERS_PAYABLE_CENTER = new CommonState(37, '其他应收款(总部)红数', 'Others Payable (Center)')
// 2、结算中心(总部)
//		上海公司（总部）在核销后生成实收付凭证
//		如果是帮分公司付款，凭证格式为  贷 其它应付 （分公司）红数
//		                                  贷 银行 正数
//		如果是帮分公司收款，凭证格式为  借 银行
//		                                  贷 其它应付（分公司）
export const OTHERS_RECEIVABLE_BRANCH = new CommonState(38, '其他应付款(分公司)红数', 'Others receivable (Branch)')
export const OTHERS_PAYABLE_BRANCH = new CommonState(39, '其他应付款(分公司)', 'Others Payable (Branch)')
// CARGO-7360，西格玛：将应付款和实付款凭证内容合并，生成一张凭证
export const ACCOUNT_RECEIVABLE_MERGE = new CommonState(40, '应收账款(合并)', 'Account Receivable Merge')
export const ACCOUNT_PAYABLE_MERGE = new CommonState(41, '应付账款(合并)', 'Account Payable Merge')
export const REVENUE_MERGE = new CommonState(42, '营业收入(合并)', 'Revenue Merge')
export const COST_MERGE = new CommonState(43, '营业成本(合并)', 'Cost Merge')
//
export const ACCOUNTS_PAYABLE = new CommonState(44, '预付账款', 'Accounts Payable')
// CARGO-83，应付收票，应付挂账 - 未结转/已结转状态：预付成本，取值按【营业成本】，避免名称歧义
export const PRE_COST = new CommonState(45, '预付成本(已结转)', 'Pre Cost(CarryOver)')
// CARGO-1194，[预付成本]改为[预付成本(已结转)]，再新增分录类型[预付成本(未结转)]
export const PRE_COST_UN = new CommonState(46, '预付成本(未结转)', 'Pre Cost(UnCarryOver)')
// CARGO-1359  添加第三方支付平台
export const THIRD_PARTY_PAYMENT_PLATFORM = new CommonState(47, '第三方支付平台', 'Third Party Payment Platform')
// CARGO-2663，实收付生成的凭证：产生汇差分录
export const EXCHANGE_DIFFERENCE_RECEIVABLE = new CommonState(48, '汇差(应收)', 'Exchange Difference Receivable')
export const EXCHANGE_DIFFERENCE_PAYABLE = new CommonState(49, '汇差(应付)', 'Exchange Difference Payable')
// BJCJ-193，进项税额转出逻辑
export const COST_TRANSFER_OUT = new CommonState(60, '营业成本(进项税转出)', 'Cost(Input tax transfer-out)')
export const TAX_PAYABLE_TRANSFER_OUT = new CommonState(61, '应付税款(进项税转出)', 'Tax Payable(Input tax transfer-out)')
// CARGO-31297，内部结算凭证都为贷方（一正一负）
export const INVOICE_INTERNAL_BLUE = new CommonState(62, '内部蓝字', 'Invoice Internal Blue')
export const INVOICE_INTERNAL_RED = new CommonState(63, '内部红字', 'Invoice Internal Red')
// BJCJ-244, 暂估费用开票后，生成冲暂估凭证
export const ACCOUNT_RECEIVABLE_ESTIMATION_OFFSET = new CommonState(64, '应收账款(暂估冲销)', 'Account Receivable(Estimation Offset)')
export const ACCOUNT_PAYABLE_ESTIMATION_OFFSET = new CommonState(65, '应付账款(暂估冲销)', 'Account Payable(Estimation Offset)')
export const REVENUE_ESTIMATION_OFFSET = new CommonState(66, '营业收入(暂估冲销)', 'Revenue(Estimation Offset)')
export const COST_ESTIMATION_OFFSET = new CommonState(67, '营业成本(暂估冲销)', 'Cost(Estimation Offset)')
export const OPERATING_COST = new CommonState(68, '营运成本', 'Operating Cost')
// CARGO-46068，水单退款
export const WATERBILL_REFUND = new CommonState(69, '水单退款', 'WaterbillRefund')
// CARGO-50174，部份核销生成凭证的格式需要调整
export const ORIGINAL_AMOUNT = new CommonState(70, '原金额', 'Original Amount')
export const WRITEOFF_BALANCE = new CommonState(71, '销账余额', 'Writeoff Balance')
export const SECOND_WRITEOFF = new CommonState(72, '二次核销', 'Second Writeoff')
// CARGO-53146，海创：金蝶云星空凭证规则调整
export const ACCOUNT_PAYABLE_PERSON = new CommonState(73, '应付账款(个人)', 'Account Payable(Person)')

/**
 * 分录分组规则
 * Entry Types
 */
export const ENTRY_TYPES = new Set([
  ACCOUNT_RECEIVABLE,
  ACCOUNT_RECEIVABLE_NO_INVOICE,
  ACCOUNT_PAYABLE,
  ACCOUNT_PAYABLE_NO_INVOICE,
  REVENUE,
  REVENUE_NO_INVOICE,
  REVENUE_DIFF,
  COST,
  COST_NO_INVOICE,
  CASH,
  BANK_DEPOSIT,
  CHECK,
  SELF,
  CASHTRANSFER,
  AGENT_BUSINESS,
  TAX_RECEIVABLE,
  TAX_PAYABLE,
  FINANCIAL_RECEIVABLE,
  FINANCIAL_PAYABLE,
  EXCHANGE_GAIN_OR_LOSS_RECEIVABLE,
  EXCHANGE_GAIN_OR_LOSS_PAYABLE,
  FINANCIAL_CLEARODD_RECEIVABLE,
  FINANCIAL_CLEARODD_PAYABLE,
  REVENUE_EXT,
  ACCOUNTS_RECEIVABLE,
  ACCOUNTS_PAYABLE,
  OTHERS_RECEIVABLE,
  OTHERS_PAYABLE,
  CUSTOMER,
  VENDOR,
  ACCOUNT_RECEIVABLE_OVERSEA,
  ACCOUNT_PAYABLE_OVERSEA,
  OTHERS_RECEIVABLE_CENTER,
  OTHERS_PAYABLE_CENTER,
  OTHERS_RECEIVABLE_BRANCH,
  OTHERS_PAYABLE_BRANCH,
  ACCOUNT_RECEIVABLE_MERGE,
  ACCOUNT_PAYABLE_MERGE,
  REVENUE_MERGE,
  COST_MERGE,
  PRE_COST,
  PRE_COST_UN,
  THIRD_PARTY_PAYMENT_PLATFORM,
  EXCHANGE_DIFFERENCE_RECEIVABLE,
  EXCHANGE_DIFFERENCE_PAYABLE,
  BANK_ACCEPTANCE_BILL,
  COMMERCIAL_ACCEPTANCE_BILL,
  INVOICE_RECEIVABLE_HEDGING,
  INVOICE_PAYABLE_HEDGING,
  COST_HEDGING,
  REVENUE_HEDGING,
  FINANCIAL_EXPENSES_RECEIVABLE,
  FINANCIAL_EXPENSES_PAYABLE,
  ODD_SHORT_ACCOUNT_RECEIVABLE,
  ODD_SHORT_ACCOUNT_PAYABLE,
  COST_TRANSFER_OUT,
  TAX_PAYABLE_TRANSFER_OUT,
  INVOICE_INTERNAL_BLUE,
  INVOICE_INTERNAL_RED,
  ACCOUNT_RECEIVABLE_ESTIMATION_OFFSET,
  ACCOUNT_PAYABLE_ESTIMATION_OFFSET,
  REVENUE_ESTIMATION_OFFSET,
  COST_ESTIMATION_OFFSET,
  OPERATING_COST,
  WATERBILL_REFUND,
  ORIGINAL_AMOUNT,
  WRITEOFF_BALANCE,
  SECOND_WRITEOFF,
  ACCOUNT_PAYABLE_PERSON
])

// ---------------------
// Business Data Type
// ---------------------

export const BIZ_REVENUE = new CommonState(1, '业务收入', 'Business Revenue')
export const BIZ_COST = new CommonState(2, '业务成本', 'Business Cost')
export const BIZ_COST_REVENUE = new CommonState(12, '业务成本&收入', 'Business Cost and Revenue')

export const INVOICE_RECEIVABLE = new CommonState(3, '应收发票', 'Invoice Receivable')
export const INVOICE_PAYABLE = new CommonState(4, '应付发票', 'Invoice Payable')
export const BILLING_RECEIVABLE = new CommonState(5, '应收帐单', 'Billing Receivable')
export const BILLING_PAYABLE = new CommonState(8, '应付帐单', 'Billing Payable')
export const BILLING_OVERSEA = new CommonState(11, '国外帐单', 'Billing Oversea')

export const RECEIPT_INTERNAL = new CommonState(6, '国内收款', 'Receipt Internal')
export const PAYMENT_INTERNAL = new CommonState(7, '国内付款', 'Payment Internal')
export const RECEIPT_FOREGIN = new CommonState(9, '国外收款', 'Receipt Foregin')
export const PAYMENT_FOREGIN = new CommonState(10, '国外付款', 'Payment Foregin')
export const RECEIPT_PAYMENT = new CommonState(13, '实际收付', 'Receipt and Payment')
// CARGO-7759，应收付对冲发票凭证
export const INVOICE_RECEIVABLE_PAYABLE = new CommonState(14, '应收付对冲发票', 'Invoice Receivable and Payable')
// CARGO-8364，预收付凭证
export const PRE_RECEIPT_PAYMENT = new CommonState(15, '预收付凭证', 'Pre Receipt Payment')
export const PRE_RECEIPT_PAYMENT_CLEAR = new CommonState(16, '预收付核销', 'Pre Receipt Payment Clear')
// CARGO-17032，付款申请生成凭证
export const BILLPAYMENT = new CommonState(17, '付款申请', 'BillPayment')
// CARGO-33921，预付账款冲回
export const RECEIPT_PAYMENT_OFFSET = new CommonState(18, '预付账款冲回', 'Pre Receipt Payment(Offset)')
// CARGO-33969，营运成本冲回
export const INVOICE_PAYABLE_OFFSET = new CommonState(19, '营运成本冲回', 'Invoice Payable(Offset)')

export const MAPPING = {
  // 业务收入：应收帐款-未开票(借方)，营业收入-未开票(贷方)
  '1': new Set([
    ACCOUNT_RECEIVABLE_NO_INVOICE,
    REVENUE_NO_INVOICE,
    EXCHANGE_GAIN_OR_LOSS_RECEIVABLE,
    EXCHANGE_GAIN_OR_LOSS_PAYABLE
  ]),
  // 业务成本：应付帐款-未开票(贷方)，营业成本-未开票(借方)
  '2': new Set([
    ACCOUNT_PAYABLE_NO_INVOICE,
    COST_NO_INVOICE,
    EXCHANGE_GAIN_OR_LOSS_RECEIVABLE,
    EXCHANGE_GAIN_OR_LOSS_PAYABLE
  ]),
  '12': new Set([
    ACCOUNT_RECEIVABLE_NO_INVOICE,
    REVENUE_NO_INVOICE,
    REVENUE_DIFF,
    ACCOUNT_PAYABLE_NO_INVOICE,
    COST_NO_INVOICE,
    EXCHANGE_GAIN_OR_LOSS_RECEIVABLE,
    EXCHANGE_GAIN_OR_LOSS_PAYABLE,
    OTHERS_RECEIVABLE,
    OTHERS_PAYABLE,
    CUSTOMER,
    VENDOR,
    ACCOUNT_RECEIVABLE_OVERSEA,
    ACCOUNT_PAYABLE_OVERSEA,
    OTHERS_RECEIVABLE_CENTER,
    OTHERS_PAYABLE_CENTER,
    TAX_RECEIVABLE,
    TAX_PAYABLE
  ]),
  // 应收发票-借:应收帐款，贷:营业收入, 应收税款
  '3': new Set([
    ACCOUNT_RECEIVABLE,
    ACCOUNT_PAYABLE, // 对冲
    REVENUE,
    TAX_RECEIVABLE,
    EXCHANGE_GAIN_OR_LOSS_RECEIVABLE,
    EXCHANGE_GAIN_OR_LOSS_PAYABLE,
    INVOICE_INTERNAL_BLUE,
    INVOICE_INTERNAL_RED,
    ACCOUNT_RECEIVABLE_ESTIMATION_OFFSET,
    REVENUE_ESTIMATION_OFFSET,
    ACCOUNT_PAYABLE_ESTIMATION_OFFSET,
    COST_ESTIMATION_OFFSET
  ]),
  // 成本发票-借:应付帐款,贷:营业成本, 应付税款
  '4': new Set([
    ACCOUNT_PAYABLE,
    ACCOUNT_RECEIVABLE, // 对冲
    COST,
    TAX_PAYABLE,
    EXCHANGE_GAIN_OR_LOSS_RECEIVABLE,
    EXCHANGE_GAIN_OR_LOSS_PAYABLE,
    PRE_COST,
    PRE_COST_UN,
    COST_TRANSFER_OUT,
    TAX_PAYABLE_TRANSFER_OUT,
    INVOICE_INTERNAL_BLUE,
    INVOICE_INTERNAL_RED,
    ACCOUNT_PAYABLE_ESTIMATION_OFFSET,
    COST_ESTIMATION_OFFSET,
    ACCOUNT_RECEIVABLE_ESTIMATION_OFFSET,
    REVENUE_ESTIMATION_OFFSET,
    OPERATING_COST
  ]),
  // 应收付对冲发票:借 应收 贷 收入 借 成本 贷 应付
  '14': new Set([
    ACCOUNT_RECEIVABLE,
    ACCOUNT_PAYABLE,
    REVENUE,
    COST,
    TAX_RECEIVABLE,
    TAX_PAYABLE,
    EXCHANGE_GAIN_OR_LOSS_RECEIVABLE,
    EXCHANGE_GAIN_OR_LOSS_PAYABLE,
    INVOICE_RECEIVABLE_HEDGING,
    INVOICE_PAYABLE_HEDGING,
    COST_HEDGING,
    REVENUE_HEDGING,
    ACCOUNT_RECEIVABLE_ESTIMATION_OFFSET,
    REVENUE_ESTIMATION_OFFSET,
    ACCOUNT_PAYABLE_ESTIMATION_OFFSET,
    COST_ESTIMATION_OFFSET
  ]),
  // （挂帐对冲）应收发票-借:营业收入（未开票），贷:营业收入, 应收税款
  '3#': new Set([
    REVENUE_NO_INVOICE,
    COST_NO_INVOICE, // 对冲
    REVENUE,
    TAX_RECEIVABLE,
    EXCHANGE_GAIN_OR_LOSS_RECEIVABLE,
    EXCHANGE_GAIN_OR_LOSS_PAYABLE
  ]),
  // （挂帐对冲）应付发票-借:营业成本（未开票），贷:营业成本, 应付税款
  '4#': new Set([
    COST_NO_INVOICE,
    REVENUE_NO_INVOICE, // 对冲
    COST,
    TAX_PAYABLE,
    EXCHANGE_GAIN_OR_LOSS_RECEIVABLE,
    EXCHANGE_GAIN_OR_LOSS_PAYABLE
  ]),
  // 应收账单-借:应收帐款，贷:营业收入, 应收税款
  '5': new Set([
    ACCOUNT_RECEIVABLE,
    REVENUE,
    EXCHANGE_GAIN_OR_LOSS_RECEIVABLE,
    EXCHANGE_GAIN_OR_LOSS_PAYABLE
  ]),
  // 成本账单-借:应付帐款,贷:营业成本
  '8': new Set([
    ACCOUNT_PAYABLE,
    COST,
    EXCHANGE_GAIN_OR_LOSS_RECEIVABLE,
    EXCHANGE_GAIN_OR_LOSS_PAYABLE
  ]),
  // （挂帐对冲）应收账单-借:营业收入（未开票），贷:营业收入
  '5#': new Set([
    REVENUE_NO_INVOICE,
    REVENUE,
    EXCHANGE_GAIN_OR_LOSS_RECEIVABLE,
    EXCHANGE_GAIN_OR_LOSS_PAYABLE
  ]),
  // 应付账单-借:营业成本（未开票），贷:营业成本
  '8#': new Set([
    COST_NO_INVOICE,
    COST,
    EXCHANGE_GAIN_OR_LOSS_RECEIVABLE,
    EXCHANGE_GAIN_OR_LOSS_PAYABLE
  ]),
  // 国内收款：银行存款（借方），应收帐款（贷方）
  '6': new Set([
    CASH,
    BANK_DEPOSIT,
    AGENT_BUSINESS,
    ACCOUNT_RECEIVABLE,
    ACCOUNT_PAYABLE, // 对冲
    FINANCIAL_RECEIVABLE,
    REVENUE_EXT,
    EXCHANGE_GAIN_OR_LOSS_RECEIVABLE,
    EXCHANGE_GAIN_OR_LOSS_PAYABLE
  ]),
  // 国外账单
  '11': new Set([
    ACCOUNT_RECEIVABLE,
    ACCOUNT_PAYABLE,
    REVENUE,
    COST,
    EXCHANGE_GAIN_OR_LOSS_RECEIVABLE,
    EXCHANGE_GAIN_OR_LOSS_PAYABLE,
    ACCOUNT_RECEIVABLE_OVERSEA,
    ACCOUNT_PAYABLE_OVERSEA,
    OTHERS_RECEIVABLE_CENTER,
    OTHERS_PAYABLE_CENTER
  ]),
  // （挂帐对冲）国外账单
  '11#': new Set([
    REVENUE_NO_INVOICE,
    COST_NO_INVOICE,
    REVENUE,
    COST,
    ACCOUNT_RECEIVABLE,
    ACCOUNT_PAYABLE,
    CASH,
    BANK_DEPOSIT,
    AGENT_BUSINESS,
    FINANCIAL_RECEIVABLE,
    FINANCIAL_PAYABLE,
    EXCHANGE_GAIN_OR_LOSS_RECEIVABLE,
    EXCHANGE_GAIN_OR_LOSS_PAYABLE
  ]),
  // 国内付款：银行存款（贷方），应付帐款（借方）
  '7': new Set([
    CASH,
    BANK_DEPOSIT,
    AGENT_BUSINESS,
    ACCOUNT_PAYABLE,
    ACCOUNT_RECEIVABLE, // 对冲
    FINANCIAL_PAYABLE,
    EXCHANGE_GAIN_OR_LOSS_RECEIVABLE,
    EXCHANGE_GAIN_OR_LOSS_PAYABLE
  ]),
  // 国外收款：银行存款（借方），应收帐款（贷方）
  '9': new Set([
    CASH,
    BANK_DEPOSIT,
    AGENT_BUSINESS,
    ACCOUNT_RECEIVABLE,
    ACCOUNT_PAYABLE, // 对冲
    FINANCIAL_RECEIVABLE,
    EXCHANGE_GAIN_OR_LOSS_RECEIVABLE,
    EXCHANGE_GAIN_OR_LOSS_PAYABLE,
    THIRD_PARTY_PAYMENT_PLATFORM
  ]),
  // 国外付款：银行存款（贷方），应付帐款（借方）
  '10': new Set([
    CASH,
    BANK_DEPOSIT,
    AGENT_BUSINESS,
    ACCOUNT_PAYABLE,
    ACCOUNT_RECEIVABLE, // 对冲
    FINANCIAL_PAYABLE,
    EXCHANGE_GAIN_OR_LOSS_RECEIVABLE,
    EXCHANGE_GAIN_OR_LOSS_PAYABLE,
    THIRD_PARTY_PAYMENT_PLATFORM
  ]),
  '13': new Set([
    CASH,
    BANK_DEPOSIT,
    CHECK,
    SELF,
    CASHTRANSFER,
    AGENT_BUSINESS,
    ACCOUNT_RECEIVABLE,
    ACCOUNT_PAYABLE, // 对冲
    ACCOUNT_PAYABLE_PERSON,
    FINANCIAL_RECEIVABLE,
    FINANCIAL_PAYABLE,
    EXCHANGE_GAIN_OR_LOSS_RECEIVABLE,
    EXCHANGE_GAIN_OR_LOSS_PAYABLE,
    FINANCIAL_CLEARODD_RECEIVABLE,
    FINANCIAL_CLEARODD_PAYABLE,
    REVENUE_EXT,
    ACCOUNTS_RECEIVABLE,
    OTHERS_RECEIVABLE,
    OTHERS_PAYABLE,
    CUSTOMER,
    VENDOR,
    OTHERS_RECEIVABLE_BRANCH,
    OTHERS_PAYABLE_BRANCH,
    ACCOUNT_RECEIVABLE_MERGE,
    ACCOUNT_PAYABLE_MERGE,
    REVENUE_MERGE,
    COST_MERGE,
    THIRD_PARTY_PAYMENT_PLATFORM,
    EXCHANGE_DIFFERENCE_RECEIVABLE,
    EXCHANGE_DIFFERENCE_PAYABLE,
    BANK_ACCEPTANCE_BILL,
    COMMERCIAL_ACCEPTANCE_BILL,
    FINANCIAL_EXPENSES_RECEIVABLE,
    FINANCIAL_EXPENSES_PAYABLE,
    ODD_SHORT_ACCOUNT_RECEIVABLE,
    ODD_SHORT_ACCOUNT_PAYABLE,
    TAX_PAYABLE,
    TAX_PAYABLE_TRANSFER_OUT,
    ACCOUNTS_PAYABLE,
    WATERBILL_REFUND,
    ORIGINAL_AMOUNT,
    WRITEOFF_BALANCE,
    SECOND_WRITEOFF
  ]),
  '15': new Set([
    CASH,
    BANK_DEPOSIT,
    CHECK,
    SELF,
    CASHTRANSFER,
    AGENT_BUSINESS,
    ACCOUNTS_RECEIVABLE,
    ACCOUNTS_PAYABLE
  ]),
  '16': new Set([
    ACCOUNT_RECEIVABLE,
    ACCOUNT_PAYABLE,
    FINANCIAL_RECEIVABLE,
    FINANCIAL_PAYABLE,
    EXCHANGE_GAIN_OR_LOSS_RECEIVABLE,
    EXCHANGE_GAIN_OR_LOSS_PAYABLE,
    FINANCIAL_CLEARODD_RECEIVABLE,
    FINANCIAL_CLEARODD_PAYABLE,
    REVENUE_EXT,
    ACCOUNTS_RECEIVABLE,
    ACCOUNTS_PAYABLE,
    TAX_PAYABLE
  ]),
  '17': new Set([
    ACCOUNT_PAYABLE,
    COST,
    EXCHANGE_GAIN_OR_LOSS_RECEIVABLE,
    EXCHANGE_GAIN_OR_LOSS_PAYABLE
  ]),
  '18': new Set([
    ACCOUNT_PAYABLE,
    ACCOUNTS_PAYABLE,
    EXCHANGE_GAIN_OR_LOSS_RECEIVABLE,
    EXCHANGE_GAIN_OR_LOSS_PAYABLE
  ]),
  '19': new Set([
    COST,
    COST_TRANSFER_OUT,
    OPERATING_COST,
    TAX_PAYABLE_TRANSFER_OUT,
    EXCHANGE_GAIN_OR_LOSS_RECEIVABLE,
    EXCHANGE_GAIN_OR_LOSS_PAYABLE
  ])
}

/**
 * 凭证分组类型
 * Business Data Types
 */
export const BIZ_DATA_TYPES = new Set([
  BIZ_REVENUE,
  BIZ_COST,
  BIZ_COST_REVENUE,
  INVOICE_RECEIVABLE,
  INVOICE_PAYABLE,
  INVOICE_RECEIVABLE_PAYABLE,
  BILLING_RECEIVABLE,
  BILLING_PAYABLE,
  BILLING_OVERSEA,
  RECEIPT_INTERNAL,
  PAYMENT_INTERNAL,
  RECEIPT_FOREGIN,
  PAYMENT_FOREGIN,
  RECEIPT_PAYMENT,
  PRE_RECEIPT_PAYMENT,
  PRE_RECEIPT_PAYMENT_CLEAR,
  BILLPAYMENT,
  RECEIPT_PAYMENT_OFFSET,
  INVOICE_PAYABLE_OFFSET
])

/**
 * 根据分录类型查找分组对应的类型
 */
export function getEntryRuleRelationDocumentRules(entryType) {
  const rules = new Set()
  for (const dataType of BIZ_DATA_TYPES) {
    const state = CommonState.getStateByCode(dataType.children, entryType)
    if (state) {
      rules.push(dataType)
    }
  }
  return rules
}

// ---------------------
// Grouping Dimension
// ---------------------
export const DIMENSION_BIZ_TYPE = new CommonState(1, '业务类型', 'Biz Type')
export const DIMENSION_DEPARTMENT = new CommonState(2, '部门', 'Department')
export const DIMENSION_SALES = new CommonState(3, '销售', 'Sales')
export const DIMENSION_MBL = new CommonState(4, '主单号', 'MBL')
export const DIMENSION_HBL = new CommonState(5, '分单号', 'HBL')
export const DIMENSION_JOB_NO = new CommonState(6, '业务号', 'Job No')
export const DIMENSION_BUSINESS_DATE = new CommonState(7, '业务日期', 'BUSINESS_DATE')
export const DIMENSION_ACCOUNT = new CommonState(8, '结算单位', 'Account')
export const DIMENSION_INVOICE_NO = new CommonState(9, '发票号', 'Invoice No')
export const DIMENSION_FINANCIAL_DATE = new CommonState(10, '财务日期', 'Financial Date')
export const DIMENSION_CURRENCY = new CommonState(11, '币种', 'Currency')
export const DIMENSION_VESSEL_VOYAGE = new CommonState(12, '船名航次', 'Vessel Voyage')
export const DIMENSION_LOADING_PORT = new CommonState(13, '起运港', 'Loading Port')
export const DIMENSION_DESTINATION_PORT = new CommonState(14, '目的港', 'Destination Port')
export const DIMENSION_CARGO_SOURCE = new CommonState(15, '揽货类型', 'Cargo Source')
export const DIMENSION_ACTUAL_AMOUNT_NO = new CommonState(16, '销账编号', 'Actual Amount No')
export const DIMENSION_BANK_ACCOUNT = new CommonState(17, '银行账号', 'Bank Account')
export const DIMENSION_BANK_DEPOSIT = new CommonState(18, '银行存款', 'Bank Deposit')
export const DIMENSION_CASH = new CommonState(19, '现金', 'Cash')
export const DIMENSION_INVOICE_DATE = new CommonState(20, '开票日期', 'Invoice Date')
export const DIMENSION_WRITEOFF_DATE = new CommonState(21, '销账日期', 'Writeoff Date')
export const DIMENSION_INVOICE_BUSINESS_DATE = new CommonState(22, '发票业务日期', 'Invoice Business Date')
export const DIMENSION_INTERNAL_EXTERNAL = new CommonState(23, '内部外部', 'Internal or External')
export const DIMENSION_CHARGE_ADJUSTMENT = new CommonState(24, '是否调整', 'Adjustment')
export const DIMENSION_CHARGE_OFFSET_STATE = new CommonState(25, '红冲状态', 'Offset State')
export const DIMENSION_AGENT_BUSINESS = new CommonState(26, '代收代付', 'Agent Business')
export const DIMENSION_CHARGE_ITEM = new CommonState(27, '收费项目', 'Charge Item')
export const DIMENSION_CUSTOMER = new CommonState(28, '委托单位', 'CUSTOMER')
export const DIMENSION_CHECK = new CommonState(29, '支票', 'Check')
export const DIMENSION_SELF = new CommonState(30, '本票', 'Self')
export const DIMENSION_CASHTRANSFER = new CommonState(31, '水单', 'CashTransfer')
// CARGO-62，请款单无法与付款凭证信息关联：付款申请单号
export const DIMENSION_BILLPAYMENTNO = new CommonState(32, '请款单号', 'BillPayment No')
// CARGO-61，主营收入，主营收入结转，需要根据免税、非免税
export const DIMENSION_DUTY_FREE = new CommonState(33, '是否免税', 'Duty Free')
// CARGO-60，应缴税费 - 销项税额（进项税额） 按税率分明细科目
export const DIMENSION_TAX_RATE = new CommonState(34, '税率', 'Tax Rate')
// CARGO-83，应付收票，应付挂账 - 未结转/已结转状态
export const DIMENSION_ACCOUNTING_CARRYOVER = new CommonState(35, '是否结转', 'Accounting CarryOver')
// CARGO-395，凭证分录分组规则新增“发票类型”
export const DIMENSION_INVOICE_TYPE = new CommonState(36, '发票类型', 'Invoice Type')
// CARGO-739，科目分组条件新增“整拼类型/操作模式”
export const DIMENSION_CONTAINERLOAD_TYPE = new CommonState(37, '整拼类型/操作模式', 'ContainerLoad Type/Operate Type')
// CARGO-5755，科目分组条件增加“账单号”
export const DIMENSION_BILLING_NO = new CommonState(38, '账单号', 'Billing No')
// CARGO-6184，凭证分录分组条件增加“是否内部往来”
export const DIMENSION_INTERNAL_PARTNER = new CommonState(39, '是否内部往来', 'Internal Partner')
// CARGO-8625 国外账单凭证可以按照账单币种进不同科目
export const DIMENSION_BILLING_CURRENCY = new CommonState(40, '账单币种', 'Billing Currency')
// CARGO-20123，锦昶实收付凭证摘要体现收付日期
export const DIMENSION_PAY_RECEIVE_DATE = new CommonState(41, '收付日期', 'PayReceive Date')
// CARGO-29470，凭证分录分组规则里增加国内国外选项
export const DIMENSION_INTERNAL_OVERSEA = new CommonState(42, '国内国外', 'Internal Oversea')
// CARGO-29470，凭证分录分组规则里增加结算部门选项
export const DIMENSION_SETTLE_DEPARTMENT = new CommonState(43, '结算部门', 'Settle Department')
export const DIMENSION_RECEIVE_DUTY_FREE = new CommonState(44, '是否应收免税', 'Receive Duty Free')
// CARGO-31721，实收付凭证 银行科目摘要体现收/付字样
export const DIMENSION_BANK_SUMMARY_ARAP = new CommonState(45, '摘要收/付', 'Bank Summary Ar/Ap')
// CARGO-31879，海得邦：应收应付凭证生成规则调整
export const DIMENSION_BILLPAYMENT_INPUTBY = new CommonState(46, '付款申请人', 'Billpayment InputBy')
export const DIMENSION_RECEIVE_ALL_INVOICED = new CommonState(47, '应收全部开票', 'Receive All Invoiced')
export const DIMENSION_RECEIVE_SAME_CURRENCY_INVOICED = new CommonState(48, '应收相同币种开票', 'Receive Same Currency Invoiced')
export const DIMENSION_RECEIVE_SAME_CHARGE_INVOICED = new CommonState(49, '应收相同费用开票', 'Receive Same Charge Invoiced')
export const DIMENSION_RECEIVE_SAME_CHARGE = new CommonState(50, '应收相同费用', 'Receive Same Charge')
export const DIMENSION_PAYABLE_ALL_INVOICED = new CommonState(51, '应付全部收票', 'Payable All Invoiced')
// CARGO-32505，海得邦：应收应付凭证生成规则调整
export const DIMENSION_INVOICE_ITEM_NAME = new CommonState(52, '发票项目名称', 'Invoice Item Name')
// CARGO-32646 兰高13855：系统凭证辅助核算项支持根据销账备注带出摘要信息
export const DIMENSION_WRITEOFF_REMARK = new CommonState(53, '销账备注', 'Write-off remarks')
// CARGO-33170 金蝶云星空-凭证格式调整
export const DIMENSION_HAS_INVOICE_NO = new CommonState(54, '是否有发票号', 'Has Invoice No')
export const DIMENSION_IF_OPERATING_COST = new CommonState(55, '是否营运成本', 'If Operating Cost')
// CARGO-34370，成基：凭证生成规则调整：【ATD、ATA、申请流水号】
export const DIMENSION_ATD = new CommonState(56, 'ATD', 'ATD')
export const DIMENSION_ATA = new CommonState(57, 'ATA', 'ATA')
export const DIMENSION_CHANGE_CHARGE_NO = new CommonState(58, '申请流水号', 'Change Charge No')
// CARGO-34805，海得邦：金蝶云星空-凭证格式调整
export const DIMENSION_CHARGE_ADVANCE = new CommonState(59, '代收垫付', 'Charge Advance')
export const DIMENSION_PRERECEIPT_TAX = new CommonState(60, '代收税金', 'PreReceipt Tax')
// CARGO-34236 辰景：收费项目新增科目显示列(有备注)
export const DIMENSION_CHARGE_GROUP = new CommonState(61, '费用组', 'Fee Group')
// CARGO-47676 根据自定义业务类型、货物大类，生成凭证（有备注）
export const DIMENSION_CUSTOM_JOB_TYPE = new CommonState(62, '自定义业务类型', 'Custom Job Type')
export const DIMENSION_CARGO_CATEGORY = new CommonState(63, '货物大类', 'Cargo Category')
// CARGO-48858 根据应收发票，应付发票，实际收付，预收付核销生成凭证时，增加业务编号与收费项目，委托单位摘要规则显示
export const DIMENSION_CHARGE_NAME_JOB_NO_CUSTOMER = new CommonState(64, '默认一条费用名-业务号-委托单位', 'Default expense name - business number - commissioning unit')
export const DIMENSION_CHARGE_JOB_NO = new CommonState(65, '默认一条费用的业务号', 'Default business number for one expense')
export const DIMENSION_TAX_NATURE = new CommonState(66, '税务性质', 'Tax nature')
export const DIMENSION_INVOICE_NATURE = new CommonState(67, '税率标识', 'Tax Rate Mark')
export const DIMENSION_ADVANCE_JOB_NO = new CommonState(68, '代垫-业务号', 'Advance Business Number')
export const DIMENSION_SOURCE_CURRENCY_SOURCE_AMOUNT = new CommonState(69, '原币币种原币金额', 'Original Currency and Amount')
// 销账ID - 用于按销账ID分组生成银行存款条目
export const DIMENSION_WRITEOFF_ID = new CommonState(70, '销账ID', 'Writeoff ID')

/**
 * Grouping Dimensions
 * 凭证分组条件
 */
export const GROUPING_DIMENSIONS = new Set([
  DIMENSION_BIZ_TYPE,
  DIMENSION_DEPARTMENT,
  DIMENSION_SALES,
  DIMENSION_MBL,
  DIMENSION_HBL,
  DIMENSION_JOB_NO,
  DIMENSION_BUSINESS_DATE,
  DIMENSION_ACCOUNT,
  DIMENSION_INVOICE_NO,
  DIMENSION_FINANCIAL_DATE,
  DIMENSION_INVOICE_DATE,
  DIMENSION_WRITEOFF_DATE,
  DIMENSION_CURRENCY,
  DIMENSION_ACTUAL_AMOUNT_NO,
  DIMENSION_BILLPAYMENTNO,
  DIMENSION_PAY_RECEIVE_DATE
])

/**
 * 科目分组条件
 */
export const ENTRY_GROUPING_DIMENSIONS = new Set([
  DIMENSION_BIZ_TYPE,
  DIMENSION_CUSTOMER,
  DIMENSION_DEPARTMENT,
  DIMENSION_SALES,
  DIMENSION_MBL,
  DIMENSION_HBL,
  DIMENSION_JOB_NO,
  DIMENSION_BUSINESS_DATE,
  DIMENSION_VESSEL_VOYAGE,
  DIMENSION_LOADING_PORT,
  DIMENSION_DESTINATION_PORT,
  DIMENSION_ACCOUNT,
  DIMENSION_CURRENCY,
  DIMENSION_INVOICE_NO,
  DIMENSION_ACTUAL_AMOUNT_NO,
  DIMENSION_FINANCIAL_DATE,
  DIMENSION_INVOICE_BUSINESS_DATE,
  DIMENSION_INVOICE_DATE,
  DIMENSION_WRITEOFF_DATE,
  DIMENSION_CARGO_SOURCE,
  DIMENSION_BANK_ACCOUNT,
  DIMENSION_BANK_DEPOSIT,
  DIMENSION_CASH,
  DIMENSION_CHECK,
  DIMENSION_SELF,
  DIMENSION_CASHTRANSFER,
  DIMENSION_AGENT_BUSINESS,
  DIMENSION_INTERNAL_EXTERNAL,
  DIMENSION_CHARGE_ADJUSTMENT,
  DIMENSION_CHARGE_OFFSET_STATE,
  DIMENSION_CHARGE_ITEM,
  DIMENSION_BILLPAYMENTNO,
  DIMENSION_DUTY_FREE,
  DIMENSION_TAX_RATE,
  DIMENSION_ACCOUNTING_CARRYOVER,
  DIMENSION_INVOICE_TYPE,
  DIMENSION_CONTAINERLOAD_TYPE,
  DIMENSION_BILLING_NO,
  DIMENSION_INTERNAL_PARTNER,
  DIMENSION_BILLING_CURRENCY,
  DIMENSION_PAY_RECEIVE_DATE,
  DIMENSION_INTERNAL_OVERSEA,
  DIMENSION_SETTLE_DEPARTMENT,
  DIMENSION_RECEIVE_DUTY_FREE,
  DIMENSION_BANK_SUMMARY_ARAP,
  DIMENSION_BILLPAYMENT_INPUTBY,
  DIMENSION_RECEIVE_ALL_INVOICED,
  DIMENSION_RECEIVE_SAME_CURRENCY_INVOICED,
  DIMENSION_RECEIVE_SAME_CHARGE_INVOICED,
  DIMENSION_RECEIVE_SAME_CHARGE,
  DIMENSION_PAYABLE_ALL_INVOICED,
  DIMENSION_INVOICE_ITEM_NAME,
  DIMENSION_WRITEOFF_REMARK,
  DIMENSION_HAS_INVOICE_NO,
  DIMENSION_IF_OPERATING_COST,
  DIMENSION_ATD,
  DIMENSION_ATA,
  DIMENSION_CHANGE_CHARGE_NO,
  DIMENSION_CHARGE_ADVANCE,
  DIMENSION_PRERECEIPT_TAX,
  DIMENSION_CHARGE_GROUP,
  DIMENSION_CUSTOM_JOB_TYPE,
  DIMENSION_CARGO_CATEGORY,
  DIMENSION_CHARGE_NAME_JOB_NO_CUSTOMER,
  DIMENSION_CHARGE_JOB_NO,
  DIMENSION_TAX_NATURE,
  DIMENSION_INVOICE_NATURE,
  DIMENSION_ADVANCE_JOB_NO,
  DIMENSION_SOURCE_CURRENCY_SOURCE_AMOUNT,
  DIMENSION_WRITEOFF_ID
])

// ---------------------
// Accounting Mode
// ---------------------
export const MODE_NORMAL = new CommonState(0, '普通记账', 'Normal')
export const MODE_HEDGE = new CommonState(1, '挂账对冲', 'Hedge')

export const ACCOUNTING_MODES = new Set([MODE_NORMAL, MODE_HEDGE])

// ---------------------
// Finance Code Mapping
// ---------------------
export const MAPPING_PARTNER = new CommonState(1, '合作伙伴', 'Partner')
export const MAPPING_DEPARTMENT = new CommonState(2, '部门', 'Department')
export const MAPPING_SALES = new CommonState(3, '销售员', 'Sales')
export const MAPPING_CURRENCY = new CommonState(4, '币种', 'Currency')
export const MAPPING_PREFIX = new CommonState(5, '凭证字', 'Prefix')
export const MAPPING_ACCOUNTING_ENTRY = new CommonState(6, '分录类型', 'Journal Type')
export const MAPPING_SE = new CommonState(7, '海运出口', 'Sea Export')
export const MAPPING_SI = new CommonState(8, '海运进口', 'Sea Import')
export const MAPPING_AE = new CommonState(9, '空运出口', 'Air Export')
export const MAPPING_AI = new CommonState(10, '空运进口', 'Air Import')
export const MAPPING_INTERNAL = new CommonState(11, '内部', 'Internal')
export const MAPPING_BUSINESS_TYPE = new CommonState(12, '业务类型', 'Business Type')
export const MAPPING_STAFF = new CommonState(13, '职员', 'Staff')
// CARGO-8501，增加现金流量项目核算
export const MAPPING_CASHFLOW_ITEM = new CommonState(14, '现金流量项目', 'Cashflow Item')
// CARGO-19044，锦昶：导出凭证时客户编码的取值调整
export const MAPPING_INVOICE_TITLE = new CommonState(15, '开票抬头', 'InvoiceTitle')
export const MAPPING_RECEIPT_OR_PAYMENT = new CommonState(16, '收付款方式', 'Method of receipt and payment')

/**
 * 编辑映射类型
 */
export const MAPPING_TYPES = new Set([
  MAPPING_PARTNER,
  MAPPING_DEPARTMENT,
  MAPPING_SALES,
  MAPPING_CURRENCY,
  MAPPING_PREFIX,
  MAPPING_ACCOUNTING_ENTRY,
  MAPPING_SE,
  MAPPING_SI,
  MAPPING_AE,
  MAPPING_AI,
  MAPPING_INTERNAL,
  MAPPING_BUSINESS_TYPE,
  MAPPING_STAFF,
  MAPPING_CASHFLOW_ITEM,
  MAPPING_INVOICE_TITLE,
  MAPPING_RECEIPT_OR_PAYMENT
])

// ---------------------
// Operation
// ---------------------
export const OPERATION_EQUAL = new CommonState('=', '等于', 'Equal')
export const OPERATION_UNEQUAL = new CommonState('!=', '不等于', 'Unequal')

/**
 * 操作符
 */
export const OPERATIONS = new Set([
  OPERATION_EQUAL,
  OPERATION_UNEQUAL
])

// ---------------------
// Voucher State
// ---------------------
export const VOUCHER_ALL = new CommonState(null, '所有', 'All')
export const VOUCHER_UNAUDITED = new CommonState(0, '未审核', 'Unaudited')
export const VOUCHER_AUDITED = new CommonState(1, '已审核', 'Audited')
export const VOUCHER_EXPORTED = new CommonState(2, '已导出', 'Exported')
export const VOUCHER_OFFSET = new CommonState(3, '红冲', 'Offset')
export const VOUCHER_OFFSETED = new CommonState(4, '被红冲', 'Offseted')

/**
 * 凭证状态
 */
export const VOUCHER_STATES = new Set([
  VOUCHER_UNAUDITED,
  VOUCHER_AUDITED,
  VOUCHER_EXPORTED
])

export const PUSH_SUCCESS = new CommonState(1, '已推送', 'Pushed')
export const PUSH_INIT = new CommonState(0, '未推送', 'Not pushed')

/**
 * 推送状态
 */
export const PUSH_STATES = new Set([
  PUSH_SUCCESS,
  PUSH_INIT
])

export const VOUCHER_STATES2 = new Set([
  VOUCHER_ALL,
  VOUCHER_UNAUDITED,
  VOUCHER_AUDITED,
  VOUCHER_EXPORTED
])

/**
 * 是否是应收类型分录
 */
export function isArEntry(type, bizType) {
  let isAr = false
  if (
    ACCOUNT_RECEIVABLE.code === type ||
    ACCOUNT_RECEIVABLE_NO_INVOICE.code === type ||
    CUSTOMER.code === type ||
    ACCOUNT_PAYABLE_OVERSEA.code === type ||
    OTHERS_RECEIVABLE_CENTER.code === type ||
    ACCOUNT_RECEIVABLE_MERGE.code === type ||
    COST_MERGE.code === type ||
    REVENUE.code === type ||
    REVENUE_NO_INVOICE.code === type ||
    TAX_RECEIVABLE.code === type ||
    FINANCIAL_RECEIVABLE.code === type ||
    ACCOUNTS_RECEIVABLE.code === type ||
    ACCOUNT_RECEIVABLE_ESTIMATION_OFFSET.code === type ||
    REVENUE_ESTIMATION_OFFSET.code === type ||
    (CASH.code === type || BANK_DEPOSIT.code === type || AGENT_BUSINESS.code === type || BANK_ACCEPTANCE_BILL.code === type) && (bizType === RECEIPT_INTERNAL.code || bizType === RECEIPT_FOREGIN.code)) {
    isAr = true
  }
  return isAr
}
